export const YEAR_FORMAT = 'YYYY';
export const DENOMINATOR_DATE_FORMAT = 'YYYY MM DD';
export const REFERENCE_DATE_FORMAT = 'YYYY MM';
